function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  x: "-4.7%",
  y: "-8.3%",
  width: "109.5%",
  height: "116.6%",
  filterUnits: "objectBoundingBox",
  id: "benefit_school_svg__b"
}, /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.775,
  "in": "SourceGraphic"
})), /*#__PURE__*/React.createElement("rect", {
  id: "benefit_school_svg__a",
  x: 0,
  y: 2.868,
  width: 90,
  height: 90,
  rx: 45
}));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(0 .132)",
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("use", {
  fill: "#73B84E",
  xlinkHref: "#benefit_school_svg__a"
}), /*#__PURE__*/React.createElement("use", {
  fillOpacity: 0.9,
  fill: "#FFF",
  xlinkHref: "#benefit_school_svg__a"
}), /*#__PURE__*/React.createElement("circle", {
  stroke: "#DA4D7A",
  strokeWidth: 2,
  cx: 81,
  cy: 14.868,
  r: 5
}), /*#__PURE__*/React.createElement("circle", {
  fill: "#45C94E",
  cx: 5,
  cy: 75.868,
  r: 5
}), /*#__PURE__*/React.createElement("path", {
  fill: "#0086D8",
  d: "M79 43.868h36v10H79z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.377 0c.592 0 1.072.48 1.072 1.071v2.857h2.857c.552 0 1.007.418 1.065.955l.006.117c0 .592-.48 1.071-1.07 1.071h-2.859v2.858c0 .552-.417 1.007-.954 1.065l-.117.006c-.591 0-1.07-.48-1.07-1.071L9.304 6.07H6.45a1.072 1.072 0 01-1.065-.954L5.377 5c0-.592.48-1.071 1.072-1.071l2.856-.001.001-2.857c0-.552.418-1.007.955-1.065z",
  fill: "#F9BA48",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("path", {
  d: "M90.377 74c.592 0 1.072.48 1.072 1.071v2.857h2.857c.552 0 1.007.418 1.065.955l.006.117c0 .592-.48 1.071-1.07 1.071h-2.859v2.858c0 .552-.417 1.007-.954 1.065l-.117.006c-.591 0-1.07-.48-1.07-1.071l-.002-2.858H86.45a1.072 1.072 0 01-1.065-.954L85.377 79c0-.592.48-1.071 1.072-1.071l2.856-.001.001-2.857c0-.552.418-1.007.955-1.065z",
  fill: "#F99848",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M65.307 79.004c-5.896 1.079-14.889 2.007-23.213 1.81-8.325-.2-16.232-1.545-19.99-3.041-3.745-1.497-3.327-3.143 1.698-3.768 5.039-.623 14.962-.198 20.758.102 5.81.3 7.494.478 12.187.683 4.68.205 12.746-.112 15.183.62 2.452.733-.727 2.512-6.623 3.594z",
  fill: "#86BDDC",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("path", {
  fillOpacity: 0.25,
  fill: "#000",
  filter: "url(#benefit_school_svg__b)",
  d: "M6.543 30.052h49.018V58.1H6.543z",
  transform: "translate(15 19.868)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M18.075 32.34a.245.245 0 01.429-.076l1.072 1.434 1.822-.061a.236.236 0 01.203.375l-1.07 1.452.609 1.676c.067.185-.113.366-.304.307l-1.734-.536-1.446 1.097c-.16.121-.39.012-.39-.185l-.002-1.783-1.502-.998a.236.236 0 01.063-.422l1.733-.566.517-1.714zM38.714 20.615c.035-.11.187-.137.257-.045l.638.827 1.092-.042c.12-.005.192.123.12.216l-.646.846.358.969c.04.107-.068.213-.183.18l-1.037-.305-.87.64c-.097.071-.235.009-.234-.105l.006-1.034-.897-.573c-.099-.063-.076-.208.039-.245l1.04-.334.317-.995z",
  fill: "#FFC832",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#BBE6F6",
  strokeWidth: 0.622,
  strokeLinecap: "round",
  d: "M31.215 22.879l4.709 7.31M61.94 28.479l-5.089 7.833M67.608 35.164l-3.988 3.02M29.459 36.558l-2.792-1.771"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(17.64 24.256)",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#E6BE94",
  d: "M54.433 51.65H2.653V27.606h10.714l15.176-15.139 15.177 15.14h10.713z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#996459",
  d: "M23.187 40.964H33.9V51.65H23.187z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M33.677 37.402H23.41c-.123 0-.223.1-.223.223v3.34H33.9v-3.34c0-.123-.1-.223-.223-.223z",
  fill: "#BBE6F6"
}), /*#__PURE__*/React.createElement("path", {
  d: "M36.783 5.343l1.455-2.177a.89.89 0 00-.743-1.385h-8.927a.891.891 0 00-.893.89v5.344c0 .492.4.89.893.89h8.927a.89.89 0 00.743-1.385l-1.455-2.177z",
  fill: "#F7B500"
}), /*#__PURE__*/React.createElement("path", {
  d: "M28.568 13.358a.891.891 0 01-.893-.89V.89c0-.493.4-.891.893-.891s.893.398.893.89v11.577c0 .493-.4.89-.893.89z",
  fill: "#5C546A"
}), /*#__PURE__*/React.createElement("path", {
  d: "M32.182 16.58a.892.892 0 01.825-.55H49.97c.306 0 .59.155.754.412l6.249 9.795a.89.89 0 01-.753 1.37H42.827a.893.893 0 01-.63-.262l-9.82-9.796a.887.887 0 01-.195-.97zM24.929 16.58a.892.892 0 00-.825-.55H7.142a.894.894 0 00-.753.412l-6.25 9.795a.89.89 0 00.754 1.37h13.39a.893.893 0 00.632-.262l9.82-9.795a.888.888 0 00.194-.97z",
  fill: "#FF4F19"
}), /*#__PURE__*/React.createElement("path", {
  d: "M43.732 28.485a.89.89 0 01-.63-.261L28.567 13.727 14.035 28.224a.894.894 0 01-1.263 0 .889.889 0 010-1.26l15.165-15.126a.894.894 0 011.262 0l15.165 15.126a.889.889 0 01-.632 1.52z",
  fill: "#E23601"
}), /*#__PURE__*/React.createElement("ellipse", {
  fill: "#FFFCF5",
  cx: 28.568,
  cy: 27.606,
  rx: 5.356,
  ry: 5.343
}), /*#__PURE__*/React.createElement("path", {
  d: "M28.568 24.044a.891.891 0 00-.893.89v1.782H25.89a.891.891 0 100 1.78h2.678a.891.891 0 00.893-.89v-2.671c0-.493-.4-.89-.893-.89z",
  fill: "#5C546A"
}), /*#__PURE__*/React.createElement("path", {
  d: "M41.935 33.395c0-1.23-1-2.227-2.232-2.227a2.229 2.229 0 00-2.187 2.672h-.045v3.562h4.464V33.84h-.045c.029-.144.045-.293.045-.445z",
  fill: "#BBE6F6"
}), /*#__PURE__*/React.createElement("path", {
  d: "M39.727 30.278a3.124 3.124 0 00-3.124 3.117v4.007c0 .492.399.89.892.89h4.464a.891.891 0 00.893-.89v-4.007a3.124 3.124 0 00-3.125-3.117zm0 1.78c.739 0 1.34.6 1.34 1.337v.445h-2.679v-.445c0-.737.6-1.336 1.34-1.336zm-1.339 4.453v-.89h2.678v.89h-2.678z",
  fill: "#7E5C62"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#BBE6F6",
  d: "M15.177 41.855h4.464v5.343h-4.464z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M19.64 40.964h-4.463a.891.891 0 00-.893.89v5.344c0 .492.4.89.893.89h4.463a.891.891 0 00.893-.89v-5.343c0-.493-.4-.89-.893-.89zm-.892 1.781v.89h-2.679v-.89h2.679zm-2.679 3.562v-.89h2.679v.89h-2.679z",
  fill: "#7E5C62"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#BBE6F6",
  d: "M7.118 41.855h4.464v5.343H7.118z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.581 40.964H7.118a.891.891 0 00-.893.89v5.344c0 .492.4.89.893.89h4.463a.891.891 0 00.893-.89v-5.343c0-.493-.4-.89-.893-.89zm-.892 1.781v.89H8.01v-.89h2.679zM8.01 46.307v-.89h2.679v.89H8.01z",
  fill: "#7E5C62"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#BBE6F6",
  d: "M45.53 41.855h4.464v5.343H45.53z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M49.994 40.964H45.53a.891.891 0 00-.893.89v5.344c0 .492.4.89.893.89h4.464a.891.891 0 00.893-.89v-5.343c0-.493-.4-.89-.893-.89zm-.893 1.781v.89h-2.678v-.89H49.1zm-2.678 3.562v-.89H49.1v.89h-2.678z",
  fill: "#7E5C62"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#BBE6F6",
  d: "M37.471 41.855h4.464v5.343h-4.464z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M41.935 40.964H37.47a.891.891 0 00-.893.89v5.344c0 .492.4.89.893.89h4.464a.891.891 0 00.892-.89v-5.343c0-.493-.399-.89-.892-.89zm-.893 1.781v.89h-2.678v-.89h2.678zm-2.678 3.562v-.89h2.678v.89h-2.678z",
  fill: "#7E5C62"
}), /*#__PURE__*/React.createElement("path", {
  d: "M49.945 33.395c0-1.23-1-2.227-2.232-2.227a2.229 2.229 0 00-2.187 2.672h-.045v3.562h4.464V33.84H49.9c.03-.144.045-.293.045-.445z",
  fill: "#BBE6F6"
}), /*#__PURE__*/React.createElement("path", {
  d: "M47.737 30.278a3.124 3.124 0 00-3.124 3.117v4.007c0 .492.4.89.893.89h4.463a.891.891 0 00.893-.89v-4.007a3.124 3.124 0 00-3.125-3.117zm0 1.78c.739 0 1.34.6 1.34 1.337v.445h-2.679v-.445c0-.737.601-1.336 1.34-1.336zm-1.339 4.453v-.89h2.679v.89h-2.679z",
  fill: "#7E5C62"
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M11.557 33.395c0-1.23-1-2.227-2.232-2.227a2.229 2.229 0 00-2.187 2.672h-.045v3.562h4.464V33.84h-.045c.03-.144.045-.293.045-.445z",
  fill: "#BBE6F6"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.35 30.278a3.124 3.124 0 00-3.125 3.117v4.007c0 .492.4.89.893.89h4.463a.891.891 0 00.893-.89v-4.007a3.124 3.124 0 00-3.125-3.117zm0 1.78c.738 0 1.339.6 1.339 1.337v.445H8.01v-.445c0-.737.601-1.336 1.34-1.336zm-1.34 4.453v-.89h2.679v.89H8.01z",
  fill: "#7E5C62"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M19.567 33.395c0-1.23-.999-2.227-2.232-2.227a2.229 2.229 0 00-2.187 2.672h-.045v3.562h4.464V33.84h-.045c.03-.144.045-.293.045-.445z",
  fill: "#BBE6F6"
}), /*#__PURE__*/React.createElement("path", {
  d: "M17.36 30.278a3.124 3.124 0 00-3.125 3.117v4.007c0 .492.4.89.893.89h4.464a.891.891 0 00.892-.89v-4.007a3.125 3.125 0 00-3.124-3.117zm0 1.78c.738 0 1.339.6 1.339 1.337v.445H16.02v-.445c0-.737.6-1.336 1.339-1.336zm-1.34 4.453v-.89H18.7v.89H16.02z",
  fill: "#7E5C62"
})), /*#__PURE__*/React.createElement("path", {
  d: "M28.568 33.84c-3.446 0-6.25-2.796-6.25-6.234 0-3.437 2.804-6.233 6.25-6.233s6.25 2.796 6.25 6.233c0 3.438-2.804 6.234-6.25 6.234zm0-10.686a4.463 4.463 0 00-4.464 4.452 4.463 4.463 0 004.464 4.453 4.463 4.463 0 004.464-4.453 4.463 4.463 0 00-4.464-4.452zM32.139 36.511h-7.142a2.678 2.678 0 00-2.678 2.672V51.65c0 .493.399.89.892.89a.891.891 0 00.893-.89v-9.795h3.547v9.795h1.785v-9.795h3.596v9.795c0 .493.399.89.892.89a.891.891 0 00.893-.89V39.183a2.678 2.678 0 00-2.678-2.672zm.893 3.563h-8.928v-.891c0-.491.4-.89.893-.89h7.142c.492 0 .893.399.893.89v.89z",
  fill: "#7E5C62"
}), /*#__PURE__*/React.createElement("path", {
  d: "M54.349 52.54H2.6c-.462 0-.835-.397-.835-.89 0-.492.373-.89.835-.89h51.748c.461 0 .834.398.834.89 0 .493-.373.89-.834.89z",
  fill: "#5C546A"
}))));

function SvgBenefitSchool(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 115,
    height: 94,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _ref, _ref2);
}

export default __webpack_public_path__ + "static/benefit_school.692586b5.svg";
export { SvgBenefitSchool as ReactComponent };